module.exports = __webpack_public_path__ + "media/images/error-10e299c3.png";